import { render, staticRenderFns } from "./money.vue?vue&type=template&id=2f68af9e&scoped=true"
import script from "./money.vue?vue&type=script&lang=js"
export * from "./money.vue?vue&type=script&lang=js"
import style0 from "./money.vue?vue&type=style&index=0&id=2f68af9e&prod&lang=scss"
import style1 from "./money.vue?vue&type=style&index=1&id=2f68af9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68af9e",
  null
  
)

export default component.exports